import React from "react";

const ListGates = () => {
  return <div>list Gates</div>;
};

export default React.memo(ListGates);
